import { createContext, useContext, useState, type ReactNode } from 'react';

interface AppContextType {
  username: string | null;
  setUsername: (name: string) => void;
  logout: () => void;
}

const AppContext = createContext<AppContextType | null>(null);

export function useAppContext() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useAppContext must be used within AppContextProvider');
  return ctx;
}

export function AppContextProvider({ children }: { children: ReactNode }) {
  const [username, setUsernameState] = useState<string | null>(() => {
    if (typeof window === 'undefined') return null;
    return localStorage.getItem('hashups_username');
  });

  function setUsername(name: string) {
    localStorage.setItem('hashups_username', name);
    setUsernameState(name);
  }

  function logout() {
    localStorage.removeItem('hashups_username');
    setUsernameState(null);
  }

  return (
    <AppContext.Provider value={{ username, setUsername, logout }}>
      {children}
    </AppContext.Provider>
  );
}
